"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectSingleAppointmentScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
var _ = require("../..");
var _components = require("../../../components");
var _CubbyFooter = _interopRequireDefault(require("../CubbyFooter"));
var _SelectedSlotMessage = require("./SelectedSlotMessage");
var _utils2 = require("../utils");
var _useManagerAppointmentCubby = require("../useManagerAppointmentCubby");
var _ScreenTitle = require("./ScreenTitle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SelectSingleAppointmentScreen = function SelectSingleAppointmentScreen(_ref) {
  var showOnlyManagedAvailability = _ref.showOnlyManagedAvailability;
  var _useManagerAppointmen = (0, _useManagerAppointmentCubby.useManagerAppointmentCubby)(),
    patient = _useManagerAppointmen.patient,
    clinician = _useManagerAppointmen.clinician,
    appointmentScheduled = _useManagerAppointmen.appointmentScheduled,
    previousStage = _useManagerAppointmen.previousStage,
    transition = _useManagerAppointmen.transition;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSlot = _useState2[0],
    setSelectedSlot = _useState2[1];
  var _useCacheKey = (0, _utils.useCacheKey)("".concat(clinician.id, "-appointment-selector")),
    _useCacheKey2 = _slicedToArray(_useCacheKey, 2),
    appointmentSelectorKey = _useCacheKey2[0],
    onInvalidateAvailability = _useCacheKey2[1];
  var eventType = (0, _utils.getEventTypeForClinician)(clinician);
  var _useValidateTimeslot = (0, _utils2.useValidateTimeslot)(),
    validateTimeslotLoading = _useValidateTimeslot.loading,
    validateTimeslot = _useValidateTimeslot.run,
    selectedSlotAvailabilityWarning = _useValidateTimeslot.warning,
    setSelectedSlotAvailabilityWarning = _useValidateTimeslot.setWarning,
    isBookingDisabled = _useValidateTimeslot.isBookingDisabled;
  var _useRequest = (0, _utils.useRequest)(function () {
      return {
        method: 'post',
        url: (0, _utils.getCreateAppointmentUrl)(patient.id),
        data: {
          start: selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.start.toISOString(),
          end: selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.end.toISOString(),
          clinicianId: clinician.id,
          eventType: eventType
        },
        withErrorsHandler: false
      };
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        return transition('newSuccess');
      },
      onError: function onError(error) {
        setSelectedSlot(undefined);
        setSelectedSlotAvailabilityWarning(undefined);
        onInvalidateAvailability();
        (0, _utils2.handleAppointmentError)(error);
      }
    }),
    createAppointmentLoading = _useRequest.loading,
    createAppointment = _useRequest.run;
  (0, _react.useEffect)(function () {
    if (!selectedSlot) {
      return;
    }
    validateTimeslot({
      clinicianId: clinician.id,
      appointmentSlot: selectedSlot
    });
  }, [selectedSlot]);
  var clinicianArray = (0, _react.useMemo)(function () {
    return [clinician];
  }, [clinician]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h-full flex flex-col relative"
  }, /*#__PURE__*/_react.default.createElement(_ScreenTitle.ScreenTitle, {
    className: "px-[24px]"
  }, "Select an appointment slot"), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "mt-[24px] border-grey-25"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-grow h-0 overflow-y-auto"
  }, /*#__PURE__*/_react.default.createElement(_.SingleAppointmentSelector
  // The code inside SingleAppointmentSelector does not handle changing clinicians very well
  // So the simplest answer is to unmount and remount the component when the clinician changes
  // Which can be accomplished by adding a key prop
  , {
    key: appointmentSelectorKey,
    clinicians: clinicianArray,
    duration: _utils.BookingEventTypeDuration[eventType],
    value: selectedSlot,
    onSelect: setSelectedSlot,
    showOnlyManagedAvailability: showOnlyManagedAvailability
  })), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "mb-[24px] border-grey-25"
  }), /*#__PURE__*/_react.default.createElement(_CubbyFooter.default, {
    message: /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-col gap-y-[12px]"
    }, /*#__PURE__*/_react.default.createElement(_SelectedSlotMessage.SingleSelectedSlotMessage, {
      selectedSlot: selectedSlot,
      patientTimeZone: patient === null || patient === void 0 ? void 0 : patient.timeZone,
      clinicianTimeZone: clinician.timeZone
    }), selectedSlotAvailabilityWarning),
    loading: createAppointmentLoading || validateTimeslotLoading,
    actionText: "Schedule",
    actionDisabled: appointmentScheduled || createAppointmentLoading || validateTimeslotLoading || isBookingDisabled || !(selectedSlot && patient),
    onAction: createAppointment,
    cancelText: previousStage ? 'Back' : 'Cancel',
    onCancel: function onCancel() {
      return transition('back');
    }
  }));
};
exports.SelectSingleAppointmentScreen = SelectSingleAppointmentScreen;